export default __webpack_public_path__ + "static/media/iconfinder-512.02823358.png";